module.exports = __webpack_public_path__ + "static/media/rafael_oliveira.9ad502fa.webp";